module.exports = __webpack_public_path__ + "media/application/images/icons/mail-d7c2700bc11ea33934fa9a648df34db6.svg";